import { COLOR_PALETTE } from 'constants/ui';
import { getConditionalObject } from 'utils/data';

const SPACING_UNIT = 4.75;

export const programSummaryStyles = {
  width: '100%',
  flexDirection: 'row',
};

const getSummaryCellStyles = isRightIndent => ({
  pl: 2,
  pr: isRightIndent ? SPACING_UNIT : 2,
});

export const programCellContentStyles = {
  gap: 1,
};

export const amountCellContentStyles = {
  gap: 0.5,
};

export const tooltipWrapperStyles = {
  position: 'relative',
  top: '-8px',
};

export const getCellStyles = ({
  customStyles,
  isRightIndent,
  isPendingNewProgram,
  isPendingInitProgram,
}) => ({
  ...getSummaryCellStyles(isRightIndent),
  ...customStyles,

  ...getConditionalObject(isPendingNewProgram && !isPendingInitProgram, {
    color: `${COLOR_PALETTE.ADDITIONAL[2]}`,
  }),
});

export const tooltipPopperProps = {
  disablePortal: true,
};

export const unselectedProgramLabelStyles = {
  marginLeft: '-45px',

  span: {
    fontWeight: 400,
  },
};

// getEligibilityTooltip joins its lines with \n, so the tooltip has to honour them.
export const eligibilityTooltipStyles = {
  whiteSpace: 'pre-line',
};
